export default {
  'BookingEventSelction.next': { en: 'Next', fr: 'Suivante' },
  'BookingEventSelction.pleaseSelect': {
    en: 'Please select your event type',
    fr: "Veuillez sélectionner votre type d'événement",
  },
};
